if (!customElements.get('steps-slider')) {
  class StepsSlider extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.thumbSwiper = new Swiper(this.querySelector('[js-thumb-slider]'), {
        slidesPerView: 3,
        spaceBetween: 8,
        watchSlidesProgress: true,
      });

      this.mainSwiper = new Swiper(this.querySelector('[js-main-slider]'), {
        thumbs: {
          swiper: this.thumbSwiper,
        },
        navigation: {
          prevEl: this.querySelector('.swiper-arrow--prev'),
          nextEl: this.querySelector('.swiper-arrow--next'),
        },
      });
    }
  }

  customElements.define('steps-slider', StepsSlider);
}
